import { useState } from 'react';
import { DrillDownModal } from '../../../../../../../components/specific/DrillDown/index.ts';
import {
    mapVatUnusedItemsToDrillDownRows,
    type VatDeclarationUnusedItem,
} from '../../../../../../../components/specific/VatDeclaration/index.ts';
import VatReturnUnusedBillInfo from './VatReturnUnusedBillInfo.tsx';

export interface VatReturnExcludedDocumentsProps {
    businessId: string;
    unusedItems: VatDeclarationUnusedItem[];
}

export function VatReturnExcludedDocuments({ businessId, unusedItems }: VatReturnExcludedDocumentsProps) {
    const [isOpen, setIsOpen] = useState(false);
    return (
        <>
            <VatReturnUnusedBillInfo count={unusedItems.length} onViewDocuments={() => setIsOpen(true)} />
            <DrillDownModal
                open={isOpen}
                onClose={() => setIsOpen(false)}
                title="Niet meegenomen documenten"
                headingPrefix="Documenten"
                emptyMessage="Er zijn geen niet-meegenomen documenten voor deze periode."
                businessId={businessId}
                rows={mapVatUnusedItemsToDrillDownRows(unusedItems)}
            />
        </>
    );
}
